module.exports = __webpack_public_path__ + "img/moon-with-clouds-littlesnow.f42582a1.png";